import { host } from './../config/api';

export default class EcCardAPI {
  /* 4.4(get) 下載緊急支援卡 */
  static download(token) {
    return host + '/ecCard/download?token=' + token;
  }
}
